"use strict";

var FullTextSearch = (function ($, FullTextSearchService) {

    function initialize(service) {

        var fullTextSearchService = (service)
            ? service
            : new FullTextSearchService();

        var $fullTextSearchForm = $('#fullTextSearchForm #fullTextSearch');
        var fullTextSearchButton = $('#fullTextSearchForm #searchButton');

        fullTextSearchService.startSearchTextAutoSuggestion();

        $fullTextSearchForm.on("keyup", function () {
            fullTextSearchService.handleKeyup($(this));
        });

        $fullTextSearchForm.on("focus", function () {
            fullTextSearchService.handleFocus();
        });

        $(document).on("click", function (event) {
            fullTextSearchService.togglePopup(event);
        });

        $(document).on("touchend", function (event) {
            fullTextSearchService.togglePopup(event);
        });

        $(document).on("keydown", function (event) {
            fullTextSearchService.togglePopupSelect(event);
        });

        fullTextSearchButton.on("click", function () {
            fullTextSearchService.handleFullTextSearchSubmit();
        });

        $(document).on("change keydown paste input", '#fullTextSearchForm', function (event) {
            fullTextSearchService.handleEventsOnFullTextSearchForm(event);
        });

        $(document).on("click", ".search-toggle", function () {
            fullTextSearchService.handleClickSearchToggle($(this));
        });

        $(window).on("blur", function () {
            fullTextSearchService.stopSearchTextAutoSuggestion();
        });

        $(window).on("focus", function () {
            var inputString = $("#fullTextSearchForm #fullTextSearch").val();
            if (inputString) {
                return;
            }

            fullTextSearchService.startSearchTextAutoSuggestion();
        });
    }

    return {
        initialize: initialize
    };
})($, FullTextSearchService);

$(function () {
    FullTextSearch.initialize();
});